import {
  IPortfolioItemPure,
  IPortfolioWithoutLists,
} from '@/finsight/domain/vo/PortfolioMonitor/IPortfoliosCollection';

export const getMergedPortfolios = (
    statePortfolios: IPortfolioItemPure[],
    collection: IPortfolioWithoutLists[],
) => collection.map((portfolio) => {
  const statePortfolio = statePortfolios.find(({ id }) => id === portfolio.id);

  return statePortfolio ? { ...statePortfolio, ...portfolio } : portfolio;
});
